import MediaUploadProposeModal from './MediaUploadProposeModal';

export default MediaUploadProposeModal;
